import { create } from 'zustand'

type PromptInputState = {
  prompt: string | null
  hasStartedConversation: boolean
  isSpeechModeActive: boolean
  isSubmitted: boolean
  isStreaming: boolean
  isInitializingStream: boolean
  showSources: boolean
  selectedConversation: IChatConversation | undefined
  autoStartPrompt: string | null
  promptSource: string | null
  showGenerationStoppedWarning: boolean
  suggestedPrompt: string | null

  setPrompt: (prompt: string | null) => void
  clearPrompt: () => void
  setHasStartedConversation: (hasStarted: boolean) => void
  setIsSpeechModeActive: (isActive: boolean) => void
  setIsSubmitted: (isSubmitted: boolean) => void
  setIsStreaming: (isStreaming: boolean) => void
  setIsInitializingStream: (isInitializing: boolean) => void
  setShowSources: (show: boolean) => void
  setAutoStartPrompt: (prompt: string | null) => void
  setSelectedConversation: (conversation: IChatConversation | undefined) => void
  clearSelectedConversation: () => void
  setPromptSource: (source: string | null) => void
  setShowGenerationStoppedWarning: (show: boolean) => void
  setSuggestedPrompt: (prompt: string | null) => void
}

const usePromptInputStore = create<PromptInputState>()((set) => ({
  prompt: null,
  hasStartedConversation: false,
  isSpeechModeActive: false,
  isSubmitted: false,
  isInitializingStream: false,
  showSources: false,
  autoStartPrompt: null,
  promptSource: null,
  showGenerationStoppedWarning: false,
  isStreaming: false,
  selectedConversation: undefined,
  suggestedPrompt: null,

  setPrompt: (prompt) => set({ prompt }),
  clearPrompt: () => set({ prompt: null }),
  setHasStartedConversation: (hasStarted) => set({ hasStartedConversation: hasStarted }),
  setIsSpeechModeActive: (isActive) => set({ isSpeechModeActive: isActive }),
  setIsSubmitted: (isSubmitted) => set({ isSubmitted }),
  setIsInitializingStream: (isInitializing) => set({ isInitializingStream: isInitializing }),
  setShowSources: (show) => set({ showSources: show }),
  setAutoStartPrompt: (prompt) => set({ autoStartPrompt: prompt }),
  setPromptSource: (source) => set({ promptSource: source }),
  setShowGenerationStoppedWarning: (show) => set({ showGenerationStoppedWarning: show }),
  setIsStreaming: (isStreaming) => set({ isStreaming }),
  setSelectedConversation: (conversation) => set({ selectedConversation: conversation }),
  clearSelectedConversation: () => set({ selectedConversation: undefined }),
  setSuggestedPrompt: (prompt) => set({ suggestedPrompt: prompt }),
}))

export default usePromptInputStore
